import type { HTMLAttributes, ReactNode } from 'react';
import styles from './Badge.module.css';
import { cx } from '../../lib/cx';

export type BadgeTone = 'neutral' | 'yellow' | 'success' | 'danger' | 'chip';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
  pill?: boolean;
  dot?: boolean;
  children?: ReactNode;
}

export function Badge({ tone = 'neutral', pill, dot, className, children, ...rest }: BadgeProps) {
  return (
    <span className={cx(styles.badge, styles[tone], pill && styles.pill, className)} {...rest}>
      {dot && <span className={styles.dot} aria-hidden />}
      {children}
    </span>
  );
}
